// @flow
import {LocalizationContainer} from '@userstory/i18n';
import {RootContainer} from 'app/components/Root';
import {createAppStore} from 'app/store';
import {cancelError} from 'app/utils';
import {initCentrifuge, subscribeNotificationChannel} from 'modules/centrifuge/actions';
import {NotificationContainer} from 'modules/common/components/NotificationContainer';
import {NotificationToast} from 'modules/common/components/NotificationToast';
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {ToastProvider} from 'react-toast-notifications';
import type {TAppConfig} from 'types';
import './styles/index.less';

const root = document.getElementById('root');

if (!root) {
    throw Error('Cannot find #root');
}

/**
 * Загружает конфиг приложения
 */
async function getConfig(): Promise<TAppConfig> {
    return (await fetch('/api/v1/config.json')).json();
}

(async () => {
    const config = await getConfig();

    const store = createAppStore(config);
    await store.dispatch(initCentrifuge());
    await store.dispatch(subscribeNotificationChannel());
    /**
     * Рендер компонента в DOM
     * @param App Компонент
     */
    function render(App) {
        ReactDOM.render(
            <Provider store={store}>
                <LocalizationContainer onError={cancelError}>
                    <ToastProvider autoDismissTimeout={5000} components={{Toast: NotificationToast, ToastContainer: NotificationContainer}}>
                        <BrowserRouter>
                            <App />
                        </BrowserRouter>
                    </ToastProvider>
                </LocalizationContainer>
            </Provider>,
            root
        );
    }

    render(RootContainer);

    if (module.hot) {
        module.hot.accept('app/components/Root', () => render(RootContainer));
    }
})();
